import { type ModuleData, ModuleProvider, useModule } from '#providers'
import { SendBudgetHelperPdfDto } from './BudgetConsumerEmail.types'

interface BudgetConsumerEmailConfig {
	isFinalFlow: boolean
	sendBudgetHelperPdf: (data: SendBudgetHelperPdfDto) => Promise<void>
}

interface BudgetConsumerEmailData {}

export type BudgetConsumerEmailModuleData = ModuleData<
	BudgetConsumerEmailData,
	void,
	BudgetConsumerEmailConfig
>

export const BudgetConsumerEmailModuleProvider: typeof ModuleProvider<BudgetConsumerEmailModuleData> =
	ModuleProvider

export const useBudgetConsumerEmailModule: typeof useModule<BudgetConsumerEmailModuleData> =
	useModule
